import { load } from 'recaptcha-v3';
import Pristine from 'pristinejs';

import '../../sass/blocks/contact.scss';

(() => {
    const $contacts = document.querySelectorAll('.contact');

    if (!$contacts) return;

    const { RECAPTCHA_V3_SITE_KEY } = GLOBALS;

    $contacts.forEach($contact => {
        const $form = $contact.querySelector('.contact__form');

        const initForm = () => {
            if (!$form) return;

            var pristine = new Pristine($form);

            $form.addEventListener('submit', e => {
                $form.classList.add('loading');

                e.preventDefault();

                if (!pristine.validate()) {
                    $form.classList.remove('loading');
                    return;
                }

                const $recaptchaTokenInput = $form.querySelector('.recaptcha-token');
        
                if (RECAPTCHA_V3_SITE_KEY && $recaptchaTokenInput) {
                    load(RECAPTCHA_V3_SITE_KEY).then((recaptcha) => {
                        recaptcha.execute('contact').then((token) => {
                            $recaptchaTokenInput.value = token;

                            $form.submit();
                        });
                    });
                } else {
                    $form.submit();
                }
            });
        };

        initForm();
    });
})()
